import { render, staticRenderFns } from "./ChatbotPage.vue?vue&type=template&id=53319638"
import script from "./ChatbotPage.vue?vue&type=script&lang=js"
export * from "./ChatbotPage.vue?vue&type=script&lang=js"
import style0 from "./ChatbotPage.vue?vue&type=style&index=0&id=53319638&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports